import React, { useMemo, useState, useEffect } from 'react';
import { CloudImageRow, CloudImageRowProps, ImageGap, ImageScale } from '@components/CloudImageRow/CloudImageRow';
import { SliderWidth, Wrapper, Container } from './InfiniteSlider.styles';

export interface InfiniteSliderProps {
  images: CloudImageRowProps;
  scrollName: string;
  stopOnHover?: boolean;
  speed?: number;
  gap?: ImageGap;
  scale?: ImageScale;
  elementId?: string;
  imageScale?: ImageScale;
  isEagerLoading?: boolean;
}

export const InfiniteSlider: React.FC<InfiniteSliderProps> = ({
  images,
  stopOnHover,
  scrollName,
  speed = 5,
  gap = { sm: 64, belowSm: 16 },
  scale,
  imageScale,
  elementId,
  isEagerLoading = false,
}) => {
  const [containerWidth, setContainerWidth] = useState<SliderWidth>({} as SliderWidth);

  const calculateContainerWidth = useMemo(() => {
    const width = { sm: 0, mobile: 0 };
    images.map((image) => {
      width.sm = width.sm + image.sm.width + gap.sm;
      width.mobile = width.mobile + image.belowSm.width + gap.belowSm;
    });
    setContainerWidth(width);
  }, [gap.belowSm, gap.sm, images]);

  useEffect(() => calculateContainerWidth, [calculateContainerWidth]);

  return (
    <Wrapper {...containerWidth}>
      <Container {...containerWidth} speed={speed * images.length} scrollName={scrollName} stopOnHover={stopOnHover}>
        <CloudImageRow
          images={[...images, ...images]}
          alignment="left"
          gap={gap}
          scale={scale}
          imageScale={imageScale}
          elementId={elementId}
          isEagerLoading={isEagerLoading}
        />
      </Container>
    </Wrapper>
  );
};
